import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import userRights from "../../components/_utils/userRights";
import { Card, Row, Col, Select, Button, Input, Tooltip, Form, Drawer, notification, Checkbox, Popconfirm, Tabs, DatePicker } from 'antd'
import { TableComp } from 'sz-react-utils'
import Request, { LAPI_URL, MEDIA_URL } from '../../request'
import moment from 'moment'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import { FaRupeeSign, FaUserClock, FaSignInAlt, FaUserAstronaut } from "react-icons/fa";
import { RightsWrapper } from '../../components/_utils/utils';
import AddSupportStaffSalary from './addSupportStaffSalary'
const { MonthPicker } = DatePicker
const { Option } = Select
const TabPane = Tabs.TabPane
let userCheckBox = {}
let accountPaymentCompanies = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies : '';


@Form.create()
class AllStaffOverallReport extends Component {

  state = {
    id: '',
    total: 0,
    defaultPageSize: 50,
    allUsers: [],
    approvalMonth: moment().subtract(1, 'month'),
    userCheckBox: {},
    approvalUserId: '',
    userId: '',
    activeTab: '0',
    supportStaffTab: '0',
    companyDetails: {},
    totals: {},
    approvalTotal: 0,
    shiftTiming: [],
    months: [
      {
        key: '01',
        value: 'January',
      },
      {
        key: '02',
        value: 'February',
      },
      {
        key: '03',
        value: 'March',
      },
      {
        key: '04',
        value: 'April',
      },
      {
        key: '05',
        value: 'May',
      },
      {
        key: '06',
        value: 'June',
      },
      {
        key: '07',
        value: 'July',
      },
      {
        key: '08',
        value: 'August',
      },
      {
        key: '09',
        value: 'September',
      },
      {
        key: '10',
        value: 'October',
      },
      {
        key: '11',
        value: 'November',
      },
      {
        key: '12',
        value: 'December',
      }
    ],
    years: [],
    filterYear: '',
    filterMonth: '',
    paidLeaves: 0,
    deduction: 0,
    supportSalaryId: '',
    epf: 0,
    supportStafftotal: 0,
    esic: 0,
    approvalExportParams: {},
    showSupportStaffSalaryDrawer: false,
    salaryManagementTab: "0",
    localUser: {},
    salaryId: '',
    salaryManagementTotal: 0,
    details: [],
    workingDays: [{ id: "Monday", display: "Monday" }, { id: "Tuesday", display: "Tuesday" }, { id: "Wednesday", display: "Wednesday" },
    { id: "Thursday", display: "Thursday" }, { id: "Friday", display: "Friday" }, { id: "Saturday", display: "Saturday" }, { id: "Sunday", display: "Sunday" }]
  }


  // Salary Approval Start

  handleApprovalMonthChange = (month, dateString) => {
    this.setState({ approvalMonth: moment(month) }, () => {
      this.reload()
    })
  }

  apiApprovalRequest = params => {
    return new Promise(async (resolve) => {
      if (this.state.approvalUserId !== '') {
        params.userId = this.state.approvalUserId
      }
      params.sortField = 'name'
      params.sortOrder = 'ascend'
      params.deleted = false
      params.attendanceYearMonth = moment(this.state.approvalMonth).format('YYYY-MM')
      let response = await Request.getStaffPayrolls(params);
      // let response = await Request.getStaffPayrolls(params)
      this.setState({ approvalTotal: response.total, approvalExportParams: params, totals: response.totals })
      resolve(response)
    })
  }

  handleApprovalDelete = async (recordId) => {
    let response = await Request.deleteSalaryRequest(recordId)
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: 'Something Went Wrong'
      })
    }
    this.reload()
  }

  exportApprovalExcel = async () => {
    const { approvalExportParams } = this.state
    this.setState({ exportLoading: true })
    let x = await Request.exportStaffSalariesToExcel({ ...approvalExportParams })
    this.setState({ exportLoading: false })

    if (!x.error) {
      window.open(x.url)
    }
  }


  addSupportStaffSalary = async () => {
    this.setState({ showSupportStaffSalaryDrawer: true })
  }

  closeSupportStaff = () => {
    this.setState({ showSupportStaffSalaryDrawer: false })
  }


  loadSupportStaff = async () => {
    let supportStaffReport = await Request.getSupportStaffSalary()
    let supportStaff = []
    let allUsers = this.state.allUsers
    supportStaffReport.data.map((user, index) => {
      supportStaff.push({
        _id: user._id,
        display: user.name,
      })
      allUsers.push({
        _id: user._id,
        display: user.name
      })
    })
    this.setState({ supportStaff: supportStaff, allUsers: allUsers })
  }
  // Salary Approval End


  // Support Staff Salary Start


  changeSupportStaff = (value) => {
    if (value) {
      this.chooseSupportSalaryTab(value)
    }
  }

  chooseSupportSalaryTab(value) {
    this.setState({
      supportStaffTab: value
    })
  }


  apiSupoortRequest = (params) => {
    return new Promise(async resolve => {
      let data = await Request.getSupportStaffSalary({
        ...params,
        regExFilters: []
      })
      this.setState({ supportStafftotal: data.total })
      resolve(data)
    })
  }

  handleSupportSalarySubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.supportSalaryId) {
          values._id = this.state.supportSalaryId
          x = await Request.updateSupportStaffSalary(values)
          // x = await Request.updateStaffSalaryList(values)
        } else {
          x = await Request.addSupportStaffSalary(values)
          //   x = await Request.addStaffSalaryList(values)
        }

        if (!x.error) {
          this.setState({
            supportSalaryId: '',
            supportStaffTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Support Staff Salary Updated Successfully`
              : 'Support Staff Salary Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteSupportStaffSalary = async data => {
    this.setState({ loading: true })
    await Request.deleteSupportStaffSalary(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }

  setSupportStaffSalaryData(staffSalaryId) {
    if (staffSalaryId) {
      Request.supportStaffSalaryById({ id: staffSalaryId }).then(({ doc, error, message }) => {
        if (!error && doc) {
          this.setState({
            supportSalaryId: doc._id,
            supportStaffTab: '1'
          })
          this.props.form.setFieldsValue({
            name: doc.name,
            staffSalary: doc.staffSalary,
            fatherName: doc.fatherName,
            company: doc.company,
            empId: doc.empId,
            joiningSalary: doc.joiningSalary
          })
        } else {
          notification.error({
            message: 'Error Getting Data'
          })
        }
      })
    }
  }


  // Support Staff Salary End


  // Salary Management Start

  salaryCallBack = (value) => {
    if (value) {
      this.chooseSalaryTab(value)
    }
  }

  chooseSalaryTab(value) {
    this.setState({
      salaryManagementTab: value
    })
  }


  apiSalaryRequest = params => {
    return new Promise(async resolve => {
      let data = await Request.getStaffSalaryList({
        ...params,
        regExFilters: ["staffName"]
      })
      this.setState({ salaryManagementTotal: data.total })
      resolve(data)
    })
  }

  handleSalarySubmit = (e) => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.salaryId) {
          values._id = this.state.salaryId
          x = await Request.updateStaffSalaryList(values)
        } else {
          x = await Request.addStaffSalaryList(values)
        }

        if (!x.error) {
          this.setState({
            salaryId: '',
            salaryManagementTab: '0',
          })
          notification.success({
            message: this.state.salaryId
              ? `Staff Salary Updated Successfully`
              : 'Staff Salary Added successfully'
          })
          if (!this.state.salaryId) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  loadShiftTiming = async () => {
    let params = {
      results: 1000,
      count: 1000
    }
    let response = await Request.getAllShiftTimings(params)
    let shiftTiming = []
    _.each(response.data, (item) => {
      shiftTiming.push({ id: item.shiftTime, display: item.shiftTime })
    })
    this.setState({ shiftTiming: shiftTiming })
  }


  setStaffSalaryListData(staffSalaryId) {
    if (staffSalaryId) {
      Request.staffSalaryByID({ id: staffSalaryId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              salaryId: doc._id,
              salaryManagementTab: '1'
            })
            let timing = doc.shiftTiming.split(' - ')
            this.props.form.setFieldsValue({
              staffId: doc.staffId,
              company: doc.company,
              staffSalary: doc.staffSalary,
              shiftTiming: doc.shiftTiming,
              workingDays: doc.workingDays
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }

  deleteStaffSalaryList = async data => {
    this.setState({ loading: true })
    await Request.deleteStaffSalaryList(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }

  // Salary Management End

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1],
        },
      },
      () => {
        this.reload();
      }
    );
    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload();
      }, 500);
    }
  };
  onOk = value => {
    this.reload()
  }
  reload = () => {
    this.table.current.reload();
  };
  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      if (this.state.userId) {
        params.userId = this.state.userId;
      }
      if (this.state.filterYear && this.state.filterYear) {
        params.filterYear = this.state.filterYear;
      }
      if (this.state.filterMonth && this.state.filterMonth) {
        params.filterMonth = this.state.filterMonth;
      }
      let data = await Request.getStaffOverallReport({
        ...params
      });
      let supportStaffReport = await Request.getSupportStaffSalary()
      let userArray = [];
      if (data.allUsers) {
        data.allUsers.map((user, index) => {
          userArray.push({
            _id: user._id,
            display: user.name
          })
        })
      }
      supportStaffReport.data.map((user, index) => {
        userArray.push({
          _id: user._id,
          display: user.name
        })
      })
      // _.each(data.data, (item)=>{
      //   if(!userCheckBox[item.userId]) {
      //     userCheckBox[item.userId] = {
      //       userId: item.userId,
      //       isChecked: false,
      //       isDeductChecked: false,
      //       isPreviousAdjustmentChecked: false,
      //       previousAdjustmentAmount: 0,
      //       hoursDeductAmount: 0
      //     }
      //   }
      // })
      userCheckBox = {};
      _.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            userId: item.userId,
            isChecked: false,
            isDeductChecked: false,
            isPreviousAdjustmentChecked: false,
            previousAdjustmentAmount: 0,
            hoursDeductAmount: 0
          }
        }
      })
      this.setState({ total: data.total, allUsers: userArray, paidLeaves: data.paidLeaves, deduction: data.deduction, userCheckBox: userCheckBox, details: data.data })
      resolve(data)
    })
  }

  // apiRequest = params => {
  //   return new Promise(async resolve => {
  //     this.setState({ exportParams: params })
  //     if (this.state.userId) {
  //       params.userId = this.state.userId;
  //     }
  //     if (this.state.filterYear && this.state.filterYear) {
  //       params.filterYear = this.state.filterYear;
  //     }
  //     if (this.state.filterMonth && this.state.filterMonth) {
  //       params.filterMonth = this.state.filterMonth;
  //     }
  //     let data = await Request.getStaffOverallReport({
  //       ...params
  //     });
  //     let supportStaffReport = await Request.getSupportStaffSalary()
  //     let userArray = [];
  //     if (data.allUsers) {
  //       data.allUsers.map((user, index) => {
  //         userArray.push({
  //           _id: user._id,
  //           display: user.name
  //         })
  //       })
  //     }
  //     supportStaffReport.data.map((user, index) => {
  //       userArray.push({
  //         _id: user._id,
  //         display: user.name
  //       })
  //     })
  //     _.each(data.data, (item) => {
  //       if (!userCheckBox[item._id]) {
  //         userCheckBox[item._id] = {
  //           userId: item._id,
  //           isChecked: false,
  //           isDeductChecked: false,
  //           isPreviousAdjustmentChecked:false,
  //           previousAdjustmentAmount:0,
  //           hoursDeductAmount:0
  //         }
  //       }
  //     })
  //     this.setState({ total: data.total, allUsers: userArray, paidLeaves: data.paidLeaves, deduction: data.deduction, userCheckBox: userCheckBox })
  //     resolve(data)
  //   })
  // }
  componentWillMount() {

  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
    this.table.current.reload()
  }

  async componentDidMount() {
    this.loadSupportStaff()
    this.loadShiftTiming()
    let activeUser = JSON.parse(localStorage.getItem('user'))

    let response = await Request.getCompanySetting({ businessId: activeUser.businessId })
    this.setState({ companyDetails: response, localUser: activeUser })
  }

  exportExcel = async () => {
    let { exportParams } = this.state
    let x = await Request.exportSalarySheet(exportParams)
    // let x = await Request.exportUsersToExcel({
    //      regExFilters: ['name'
    //     ]
    // })
    if (!x.error) {
      window.open(x.url)
    }
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  handleSendForVerification = async () => {
    let { userCheckBox, filterYear, filterMonth, details } = this.state;
    let userArr = _.filter(userCheckBox, (item) => {
      return item.isChecked === true ? item : false;
    });
    if (!userArr.length || !filterYear || !filterMonth) {
      notification.error({
        message: "Please select atleast 1 user, Year and Month",
      });
      return;
    }

    _.each(userArr, async (item) => {
      const found = details.find(d => d.userId === item.userId);
      if (found && !found.sentForConfirmation) {
        await this.sendForVerification(found, false);
      }
    })

    notification.success({
      message: 'All Confirmations Sent Successfully'
    }, () => {
      this.table.current.reload();
    })

  }

  // showWhatsAppSms = () => {
  //   let userArr = _.filter(this.state.userCheckBox, (item) => {
  //     return item.isChecked === true ? item : false;
  //   });

  //   if (userArr && userArr.length) {
  //     counsellingData = {
  //       usersData: userArr,
  //     };
  //     this.setState({ showWhatsAppSms: true });
  //   } else {
  //     notification.error({
  //       message: "Please select atleast 1 user.",
  //     });
  //   }
  // };

  handleSendForVerifications = async () => {
    let { companyDetails } = this.state
    let userArr = _.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    let datatoSend = [];
    _.each(userArr, (item) => {
      if (item && item.record && item.record.user) {
        let checkDays = this.getTotalWorkingData(item.record)
        // let extraHours = ((item.record.user.totalPaidLeaves + item.record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.totalWorkingHours) - item.hoursDeductAmount - item.previousAdjustmentAmount;
        let extraHours = ((item.record.user.totalPaidLeaves + item.record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.shortTermWorkingHours) - item.hoursDeductAmount - item.previousAdjustmentAmount;
        let timeDeduct = (item.record.user.hourDeduction ? ((item.record.user.hourDeduction) * checkDays.totalWorkingHours) : 0);

        let workingMinutes = ((parseFloat(item.record.workingMinutes) - this.convertHourstoMinute(item.record.user.hourDeduction * checkDays.totalWorkingHours)) + (this.convertHourstoMinute(item.record.user.totalPaidLeaves + item.record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.totalWorkingHours) - (item.hoursDeductAmount * 60))
        var hours = Math.floor(workingMinutes / 60);
        var minutes = workingMinutes % 60;
        let workingHours = parseFloat(hours + '.' + minutes);

        let hoursAllowed = checkDays.totalWorkingDays * checkDays.totalWorkingHours
        if (workingHours > hoursAllowed) {
          workingHours = hoursAllowed
        }
        let sendingData = {
          userId: item.record.userId,
          attendanceYearMonth: item.record.attendanceYearMonth,
          // totalHours: (workingMinutes / 60).toFixed(2),
          totalHours: workingHours,
          extraHours: extraHours,
          hourDeduction: timeDeduct,
          totalWorkedHours: workingHours,
          staffSalary: parseFloat(item.record.user.staffSalary),
          name: item.record.user.name,
          company: item.record.user.company,
          allowedWorkingHours: checkDays.totalWorkingHours,
          totalWorkingDays: checkDays.totalWorkingDays,
          epf: 0,
          esic: 0,
        }
        let salaryPerDay = item.record.user.staffSalary / checkDays.totalWorkingDays;
        let totalAllowedHours = checkDays.totalWorkingDays * checkDays.totalWorkingHours;

        let totalWorkingSalary = 0;
        if (workingHours > totalAllowedHours) {
          totalWorkingSalary = (parseFloat(salaryPerDay) * (totalAllowedHours / checkDays.totalWorkingHours)).toFixed(2)
        } else {
          let totalDays = (this.convertHourstoMinute(workingHours) / (checkDays.totalWorkingHours * 60)).toFixed(1)
          totalWorkingSalary = (parseFloat(salaryPerDay) * totalDays).toFixed(2);
        }
        if (companyDetails.deductEpfEsic === true) {
          if (parseFloat(item.record.user.joiningSalary) <= companyDetails.maxSalaryForEPF && parseFloat(item.record.user.staffSalary) <= companyDetails.maxSalaryForEPF) {
            sendingData.epf = (totalWorkingSalary * parseFloat(companyDetails.epfPercentage)) / 100;
          } else if (parseFloat(item.record.user.joiningSalary) <= companyDetails.maxSalaryForEPF && parseFloat(item.record.user.staffSalary) > companyDetails.maxSalaryForEPF) {
            sendingData.epf = (companyDetails.maxSalaryForEPF * parseFloat(companyDetails.epfPercentage)) / 100;
          }
          if (parseFloat(item.record.user.staffSalary) > companyDetails.maxSalaryForEPF && parseFloat(item.record.user.staffSalary) <= companyDetails.maxSalaryForESIC || parseFloat(item.record.user.staffSalary) <= companyDetails.maxSalaryForEPF) {
            sendingData.esic = (totalWorkingSalary * parseFloat(companyDetails.esicPercentage) / 100).toFixed(2)
          }
        }
        datatoSend.push(sendingData)
      }
    })
    let response = await Request.sendPayrollConfirmationToMany(datatoSend)
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: 'Something Went Wrong'
      })
    }
  }

  getTotalWorkingData(data) {

    let { workingDays, shiftTiming } = data.user
    let totalWorkingDays = 0;
    let employeeWorkingDays = 0;
    let employeeWeekendDays = 0;
    let extraTime = 0
    let timeDeduct = 0
    let totalWorkingHours = 0
    let shortTermWorkingHours = 0 // This is for sort Term

    totalWorkingDays = moment(data.attendanceYearMonth, 'YYYY-MM').daysInMonth()

    // Employee Working Days in a Month
    _.each(workingDays, (item) => {
      var monday = moment(data.attendanceYearMonth, 'YYYY-MM').startOf('month').day(item.toLowerCase())
      if (monday.date() > 7) monday.add(7, 'd');
      var month = monday.month();
      while (month === monday.month()) {
        employeeWorkingDays += 1
        monday.add(7, 'd')
      }
    })
    if (employeeWorkingDays < totalWorkingDays) {
      let daysDiff = totalWorkingDays - employeeWorkingDays
      employeeWeekendDays += daysDiff
    }
    // Days in a Month

    // Getting Working Hours
    if (shiftTiming) {
      let timings = shiftTiming.split(' - ');
      let startTime = moment(timings[0], 'HH:mmA')
      let endTime = moment(timings[1], 'HH:mmA')

      // totalWorkingHours = endTime.diff(startTime, 'minutes') / 60
      shortTermWorkingHours = endTime.diff(startTime, 'minutes') / 60
      totalWorkingHours = 8;
    }

    return {
      totalWorkingDays: totalWorkingDays,
      employeeWeekendDays: employeeWeekendDays,
      employeeWorkingDays: employeeWorkingDays,
      extraTime: extraTime,
      timeDeduct: timeDeduct,
      totalWorkingHours: totalWorkingHours,
      shortTermWorkingHours: shortTermWorkingHours
    }
  }



  sendForVerification = async (data, single = true) => {
    let { companyDetails, userCheckBox } = this.state;
    let foundData = userCheckBox[data['_id']];
    if (foundData && foundData.isDeductChecked == true && foundData.hoursDeductAmount) {
      data.deductExtraHours = foundData.hoursDeductAmount
    }
    if (foundData && foundData.isPreviousAdjustmentChecked == true && foundData.previousAdjustmentAmount) {
      data.previousAdjustment = foundData.previousAdjustmentAmount;
    }
    let response = await Request.sendPayrollForConfirmation(data);
    if (response.success) {
      notification.success({
        message: response.message
      })
      if (single) {
        this.table.current.reload();
      }
    } else {
      notification.error({
        message: response.message
      })
    }
  }


  // sendForVerification = async (data) => {
  //   let { companyDetails, userCheckBox } = this.state
  //   let foundData = _.find(userCheckBox, (checkBox) => {
  //     return checkBox.userId === data._id
  //   })
  //   let checkDays = this.getTotalWorkingData(data, foundData)
  //   // let extraHours = ((data.user.totalPaidLeaves + data.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.totalWorkingHours) - foundData.hoursDeductAmount ;
  //   let extraHours = ((data.user.totalPaidLeaves + data.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.shortTermWorkingHours) - foundData.hoursDeductAmount;
  //   let timeDeduct = (data.user.hourDeduction ? ((data.user.hourDeduction) * checkDays.totalWorkingHours) : 0)
  //   // let workingMinutes = ((parseFloat(data.workingMinutes) - this.convertHourstoMinute(data.user.hourDeduction * checkDays.totalWorkingHours)) + (this.convertHourstoMinute(data.user.totalPaidLeaves + data.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.totalWorkingHours) - (foundData.hoursDeductAmount * 60))
  //   let workingMinutes = ((parseFloat(data.workingMinutes) - this.convertHourstoMinute(data.user.hourDeduction * checkDays.totalWorkingHours)) + (this.convertHourstoMinute(data.user.totalPaidLeaves + data.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.shortTermWorkingHours) - (foundData.hoursDeductAmount * 60))
  //   var hours = Math.floor(workingMinutes / 60);
  //   var minutes = workingMinutes % 60;
  //   var formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  //   let workingHours = parseFloat(hours + '.' + formattedMinutes);
  //   let totalHoursWorked = Math.floor(data.workingMinutes / 60);
  //   let totalMinutesWorked = data.workingMinutes % 60;
  //   let totalTimeWorked = parseFloat(totalHoursWorked + '.' + totalMinutesWorked);
  //   let hoursAllowed = checkDays.totalWorkingDays * checkDays.totalWorkingHours
  //   if (workingHours > hoursAllowed) {
  //     workingHours = hoursAllowed
  //   }
  //   // let dataToSend = {
  //   //   userId: data.userId,
  //   //   attendanceYearMonth: data.attendanceYearMonth,
  //   //   totalHours: (workingMinutes / 60).toFixed(2),
  //   //   extraHours: extraHours,
  //   //   hourDeduction: timeDeduct,
  //   //   totalWorkedHours: (workingMinutes / 60).toFixed(2),
  //   //   staffSalary: parseFloat(data.user.staffSalary),
  //   //   allowedWorkingHours: checkDays.totalWorkingHours,
  //   //   totalWorkingDays: checkDays.totalWorkingDays,
  //   //   name: data.user.name,
  //   //   company: data.user.company,
  //   //   epf: 0,
  //   //   esic: 0,
  //   // }
  //   let dataToSend = {
  //     userId: data.userId,
  //     attendanceYearMonth: data.attendanceYearMonth,
  //     totalHours: workingHours,
  //     totalTimeWorked: totalTimeWorked,
  //     extraHours: extraHours,
  //     hourDeduction: timeDeduct,
  //     totalWorkedHours: workingHours,
  //     staffSalary: parseFloat(data.user.staffSalary),
  //     allowedWorkingHours: checkDays.totalWorkingHours,
  //     previousAdjustment: foundData.previousAdjustmentAmount,
  //     totalWorkingDays: checkDays.totalWorkingDays,
  //     name: data.user.name,
  //     company: data.user.company,
  //     epf: 0,
  //     esic: 0,
  //   }
  //   let salaryPerDay = data.user.staffSalary / checkDays.totalWorkingDays;
  //   let totalAllowedHours = checkDays.totalWorkingDays * checkDays.totalWorkingHours

  //   let totalWorkingSalary = 0;

  //   if (workingHours > totalAllowedHours) {
  //     totalWorkingSalary = (parseFloat(salaryPerDay) * (totalAllowedHours / checkDays.totalWorkingHours)).toFixed(2)
  //   } else {
  //     let totalDays = (this.convertHourstoMinute(workingHours) / (checkDays.totalWorkingHours * 60)).toFixed(1)
  //     totalWorkingSalary = (parseFloat(salaryPerDay) * totalDays).toFixed(2);
  //   }
  //   if (companyDetails.deductEpfEsic === true) {
  //     if (parseFloat(data.user.joiningSalary) <= companyDetails.maxSalaryForEPF && parseFloat(data.user.staffSalary) <= companyDetails.maxSalaryForEPF) {
  //       dataToSend.epf = (totalWorkingSalary * companyDetails.epfPercentage) / 100;
  //     } else if (parseFloat(data.user.joiningSalary) <= companyDetails.maxSalaryForEPF && parseFloat(data.user.staffSalary) > companyDetails.maxSalaryForEPF) {
  //       dataToSend.epf = (companyDetails.maxSalaryForEPF * companyDetails.epfPercentage) / 100;
  //     }
  //     if (parseFloat(data.user.staffSalary) > companyDetails.maxSalaryForEPF && parseFloat(data.user.staffSalary) <= companyDetails.maxSalaryForESIC || parseFloat(data.user.staffSalary) <= companyDetails.maxSalaryForEPF) {
  //       dataToSend.esic = (totalWorkingSalary * parseFloat(companyDetails.esicPercentage) / 100).toFixed(2)
  //     }
  //   }
  //   let response = await Request.sendPayrollForConfirmation(dataToSend)
  //   if (response.success) {
  //     notification.success({
  //       message: response.message
  //     })
  //   } else {
  //     notification.error({
  //       message: response.message
  //     })
  //   }
  // }

  selectAllUserFxn = () => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    _.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  unselectAllUserFxn = () => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    _.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  selectUser = (item, studentId, recordList) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);

    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;

    cloneUserCheckBox[recordList._id].record = recordList;
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  deductExtraHours = (item, studentId, recordList) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isDeductChecked = !cloneUserCheckBox[studentId]
      .isDeductChecked;
    cloneUserCheckBox[recordList._id].record = recordList;
    this.setState({ userCheckBox: cloneUserCheckBox });
  }

  deductPreviousAdjustments = (item, studentId, recordList) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isPreviousAdjustmentChecked = !cloneUserCheckBox[studentId]
      .isPreviousAdjustmentChecked;
    cloneUserCheckBox[recordList._id].record = recordList;
    this.setState({ userCheckBox: cloneUserCheckBox });
  }

  hoursDeductAmount = (item, studentId, recordList) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].hoursDeductAmount = Number(item);
    cloneUserCheckBox[recordList._id].record = recordList;
    this.setState({ userCheckBox: cloneUserCheckBox });
  }
  previousAdjustmentAmount = (item, studentId, recordList) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].previousAdjustmentAmount = Number(item);
    cloneUserCheckBox[recordList._id].record = recordList;
    this.setState({ userCheckBox: cloneUserCheckBox });
  }

  getSpecificDayCount = (y, m, countDay = 0) => {
    var days = new Date(y, m, 0).getDate();
    var sundays = [(8 - (new Date(m + '/01/' + y).getDay())) % 7];
    for (var i = sundays[0] + 7; i < days; i += 7) {
      sundays.push(i);
    }
    return sundays;
  }


  convertHourstoMinute = (totalHours) => {
    // return (totalHours * 60);
    totalHours = totalHours.toFixed(2);

    totalHours = totalHours.toString();
    let hours = totalHours;
    let minutes = 0;
    if (totalHours.indexOf('.')) {
      hours = totalHours.split('.')[0];
      minutes = totalHours.split('.')[1];
    }
    return Math.floor(hours * 60) + Math.round((minutes / 100) * 60)
  }

  render() {
    const { total, defaultPageSize, allUsers, shiftTiming, workingDays, id, supportStaff, months, paidLeaves, deduction, userCheckBox } = this.state;
    let years = [];
    let currentYear = moment().format('Y');
    for (let yr = 2023; yr <= currentYear; yr++) {
      years.push({
        key: yr,
        value: yr
      })
    }
    let { form: { getFieldDecorator, setFieldsValue } } = this.props
    let extraDays = this.getSpecificDayCount(moment().format('Y'), moment().format('MM'));
    let extraHours = extraDays.length * 8;

    let accountPaymentCompaniesArray = [];
    if (accountPaymentCompanies && accountPaymentCompanies.indexOf(',')) {
      accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
    }

    let localUser = JSON.parse(localStorage.getItem("user"));

    const approvalColumns = [
      {
        title: 'S No.',
        key: 'serialNumber',
        width: 60,
        fixed: true,
        render: (text, record, index) => {
          return (
            <span>{index + 1}</span>
          )
        }
      },
      {
        title: 'Employee Name',
        key: 'userId.name',
        fixed: true,
        width: 150,
        render: (text, record) => (
          <span>{record.userId && record.userId.name ? record.userId.name : record.name}</span>
        )
      },
      {
        title: 'Company',
        key: 'company'
      },
      {
        title: 'Basic Salary',
        key: 'userId.salary',
        width: 120,
        render: (text, record) => (
          <span>{record.staffSalary}</span>
          // <span>{record.userId ? record.userId.salary : record.staffSalary}</span>
        )
      },
      {
        title: 'Per Day Salary',
        key: 'perDaySalary',
        render: (text, record) => (
          <span>{parseFloat(record.perDaySalary).toFixed()}</span>
          // <span>{record.userId ? (record.userId.salary / record.totalWorkingDays).toFixed() : parseFloat(record.perDaySalary).toFixed()}</span>
        )
      },
      {
        title: 'Father Name',
        key: 'userId.fatherName',
        render: (text, record) => (
          <span>{record.userId && record.userId.fatherName ? record.userId.fatherName : record.fatherName}</span>
        )
      },
      {
        title: 'Month',
        key: 'attendanceYearMonth',
        render: (text, record) => (
          <div>{moment(text, 'YYYY-MM').format('MMMM-YYYY')}</div>
        )
      },
      {
        title: 'Total Worked Hours',
        key: 'totalHours',
        render: (text, record) => (
          <div>{record.totalWorkedHours && record.extraHours ? (record.totalWorkedHours - record.extraHours).toFixed(2) : "NA"}</div>
        )
      },
      {
        title: 'Weekly Off + Paid Leaves',
        key: 'extraHours',

      },
      {
        title: 'Leave Hours / Days',
        key: 'hourDeduction',
        render: (text, record) => (
          <div>
            <span>{record.hourDeduction ? record.hourDeduction + '/' + (record.hourDeduction / record.allowedWorkingHours) : "NA"}</span>
          </div>
        )
      },
      {
        title: 'Total Hours',
        key: 'totalWorkedHours',
        render: (text, record) => (
          <div>
            <span>{record.totalWorkedHours ? record.totalWorkedHours.toFixed(2) : "NA"}</span>
          </div>
        )
      },
      {
        title: 'Total Days',
        key: 'totalWorkedDays',
        render: (text, record) => (
          <div>
            <span>{record.totalWorkedHours ? (record.totalWorkedHours / record.allowedWorkingHours).toFixed(2) : record.totalWorkedDays}</span>
          </div>
        )
      },
      {
        title: 'Salary (Before EPF Deductions)',
        key: 'totalSalary',
        width: 150,
        render: (text, record) => (
          <div>
            <span>{record.totalSalary ? record.totalSalary.toFixed() : "NA"}</span>
          </div>
        )
      },
      {
        title: 'EPF',
        key: 'epf',
        render: (text, record) => (
          <div>
            {record.epf > 0 ? record.epf.toFixed() : 0}
          </div>
        )
      },
      {
        title: 'ESIC',
        key: 'esic',
        render: (text, record) => (
          <div>
            {record.esic > 0 ? record.esic.toFixed() : 0}
          </div>
        )
      },
      {
        title: 'CTC Deduction',
        key: 'uanDeduction',
        render: (text, record) => {
          if (record.uanNumber && record.staffSalary > 21000 || record.uanNumber && record.staffSalary > 15000 && record.staffSalary <= 21000) {
            this.setState({ uanDeduction: record.totalSalary * 25 / 100 })
            return (
              record.totalSalary * 25 / 100
            )
          }
        }
      },
      {
        title: 'Take Home Salary',
        key: 'inHandSalary',
        render: (text, record) => {
          return (
            <div>{record.totalAfterDeduction.toFixed(2)}</div>
          )
          // if (!record.uanNumber) {
          //   return (
          //     <div>{(record.totalSalary - record.epf - record.esic).toFixed()}</div>
          //   )
          // } else if (record.uanNumber && record.staffSalary > 21000) {
          //   return (
          //     <div>{record.totalSalary - (record.totalSalary * 25 / 100).toFixed()}</div>
          //   )
          // }
        }
      },
      {
        title: 'Comment',
        key: 'comment'
      },
      {
        title: 'Status',
        key: 'confirmationStatus',
        filters: [
          { text: 'Pending', value: 'Pending' },
          { text: 'Approved', value: 'Approved' },
          { text: 'Disapproved', value: 'Disapproved' }
        ],
        render: (text, record) => {
          if (text === "Approved") {
            return (
              <div style={{ background: 'green', color: 'white' }}>{text}</div>
            )
          } else if (text === "Disapproved") {
            return (
              <div style={{ background: 'red' }}>{text}</div>
            )
          } else {
            return (
              <div style={{ background: 'yellow' }}>{text}</div>
            )
          }
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => {
          return (
            <div>
              <Tooltip title="Delete Request">
                <Popconfirm
                  title="Are you sure to delete?"
                  onConfirm={() => this.handleApprovalDelete(record._id)}>
                  <Button
                    size={"small"}
                    shape="circle"
                    icon="cross"
                  />
                </Popconfirm>
              </Tooltip>
            </div>
          )
        }
      }
    ]


    const supportStaffInputTypes = {
      fields: [
        {
          label: 'Member Name',
          key: 'name',
          type: 'text',
          required: true
        },
        {
          label: 'Father Name',
          key: 'fatherName',
          type: 'text',
          required: true
        },
        {
          label: 'Staff Salary',
          key: 'staffSalary',
          required: true
        },
        {
          label: 'Joining Salary',
          key: 'joiningSalary',
          type: 'number',
          required: true
        },
        {
          label: 'Company',
          key: 'company',
          type: 'select',
          required: true,
          options: accountPaymentCompaniesArray,
          onChange: v => {
            this.props.form.setFieldsValue({ company: v })
          }
        },
        {
          label: 'Employee Id',
          key: 'empId',
          type: 'text'
        },

      ]
    }

    const supportStaffColumns = [
      {
        title: 'Staff Member',
        key: 'name',
        render: (text, record) => {
          return (<div>{record.name}</div>)
        }
      },
      {
        title: 'Father Name',
        key: 'fatherName'
      },
      // {
      //   title:'Department',
      //   key:'department',
      //   render:(text,record)=>{
      //     return(<div>{record.staffId.department}</div>)
      //   }
      // },
      {
        title: 'Staff Salary',
        key: 'staffSalary'
      },
      {
        title: 'Company',
        key: 'company'
      },
      {
        title: 'Joining Salary',
        key: 'joiningSalary'
      },
      {
        title: 'Employee Id',
        key: 'empId'
      },
      // {
      //   title:'Working Days',
      //   key:'workingDays',
      //   render:(text,record)=>(
      //     <span>{text}</span>
      //   )
      // },
      // {
      //   title:'Shift Timing',
      //   key:'shiftTiming'
      // },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Edit Support Staff Salary">
              <Button
                shape='circle'
                icon='edit'
                onClick={() => {
                  this.setSupportStaffSalaryData(record._id)
                }}
              />
            </Tooltip>
            <Tooltip title="Delete Support Staff Salary">
              <Popconfirm
                title="Are you Sure You want to delete Support Staff Salary"
                onConfirm={() => {
                  this.deleteSupportStaffSalary({ _id: record._id })
                }}
                okText="Yes"
                cancelText="No">
                <Button
                  shape="circle"
                  icon="delete"
                />
              </Popconfirm>
            </Tooltip>
          </React.Fragment>

        )
      }
      // {
      //   title: 'Action',
      //   key: 'operation',
      //   render: (text, record) => (
      //     <React.Fragment>
      //       <RightsWrapper myRight={'staffSalaryManagement.edit'}>
      //         <Tooltip title="Edit Staff Salary">
      //           <Button
      //             className={styles.btn}
      //             shape="circle"
      //             onClick={() => {
      //               this.setStaffSalaryListData(record._id)
      //             }}
      //             icon="edit"
      //           />
      //         </Tooltip>
      //       </RightsWrapper>
      //       <RightsWrapper myRight={'staffSalaryManagement.delete'}>
      //         <Tooltip title="Delete Staff Salary">
      //           <Popconfirm
      //             title="Are you sure delete this Staff Salary?"
      //             onConfirm={() => {
      //               this.deleteStaffSalaryList({_id: record._id})
      //             }}
      //             okText="Yes"
      //             cancelText="No">
      //             <Button
      //               className={styles.btn}
      //               shape="circle"
      //               icon="delete"
      //             />
      //           </Popconfirm>
      //         </Tooltip>
      //       </RightsWrapper>
      //     </React.Fragment>
      //   )
      // }
    ]

    // const columns = [
    //   {
    //     title: 'User Name',
    //     key: 'userId',
    //     dataIndex: 'userId',
    //     render: (text, record) => (
    //       <div> <a href={`staff-login-history?id=${record.userId}&yearMonth=${record.attendanceYearMonth}`}><FaUserAstronaut /> {record.user.name} </a></div>
    //     )
    //   },
    //   {
    //     title: 'Month',
    //     key: 'attendanceYearMonth',
    //     render: (text, record) => (
    //       <div> {record.attendanceYearMonth} </div>
    //     )
    //   },
    //   {
    //     title: 'Total Worked Hours',
    //     key: 'workingMinutes',
    //     render: (text, record) => {
    //       var hours = Math.floor(record.workingMinutes / 60);
    //       var minutes = record.workingMinutes % 60;
    //       var formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    //       let workingHours = parseFloat(hours + '.' + formattedMinutes);
    //       return (
    //         <div><FaUserClock /> {workingHours} </div>
    //       )
    //     }
    //   },
    //   {
    //     title: 'Extra Hours',
    //     key: 'extraHours',
    //     render: (text, record) => {
    //       let checkDays = this.getTotalWorkingData(record, { isDeductChecked: false });
    //       console.log(checkDays);
    //       return (
    //         // <div>Paid:-{(record.user.totalPaidLeaves + record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.totalWorkingHours}</div>
    //         <div>Paid:-{(record.user.totalPaidLeaves + record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.shortTermWorkingHours}</div>
    //       )
    //     }
    //   },
    //   {
    //     title: 'Leave Hours/Days',
    //     key: 'deduction',
    //     render: (text, record) => {
    //       let checkDays = this.getTotalWorkingData(record, { isDeductChecked: false })
    //       return (
    //         // <div>{(record.user.hourDeduction ? ((record.user.hourDeduction) * checkDays.totalWorkingHours) : 0)}/{record.user.hourDeduction}</div>
    //         <div>{(record.user.hourDeduction ? ((record.user.hourDeduction) * checkDays.shortTermWorkingHours) : 0)}/{record.user.hourDeduction}</div>
    //       )
    //     }
    //   },
    //   {
    //     title: 'Total Hours / Days',
    //     key: 'hoursDays',
    //     dataIndex: 'hoursDays',
    //     render: (text, record) => {
    //       let checkDays = this.getTotalWorkingData(record, { isDeductChecked: false });
    //       console.log(checkDays);

    //       let workingMinutes = ((parseFloat(record.workingMinutes) - this.convertHourstoMinute(record.user.hourDeduction * checkDays.shortTermWorkingHours)) + (this.convertHourstoMinute(record.user.totalPaidLeaves + record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.shortTermWorkingHours))
    //       // var hours = parseFloat(workingMinutes/60).toFixed(2);
    //       var hours = Math.floor(workingMinutes / 60);
    //       var minutes = workingMinutes % 60;
    //       var formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    //       // let workingHours = parseFloat(hours);
    //       let workingHours = parseFloat(hours + '.' + formattedMinutes);
    //       console.log(workingHours)
    //       return (
    //         <div>{workingHours}/{(workingHours / checkDays.totalWorkingHours).toFixed(2)}</div>
    //         // <div>{workingHours}/{(this.convertHourstoMinute(workingHours) / (checkDays.totalWorkingHours * 60)).toFixed(2)}</div>
    //       )
    //     }
    //   },
    //   {
    //     title: 'Salary Before Deduction',
    //     key: 'staffSalary',
    //     dataIndex: 'staffSalary',
    //     render: (text, record) => {
    //       let checkDays = this.getTotalWorkingData(record, { isDeductChecked: false })
    //       let salaryPerDay = record.user.staffSalary / checkDays.totalWorkingDays;
    //       let totalAllowedHours = checkDays.totalWorkingDays * checkDays.totalWorkingHours
    //       // let workingMinutes = ((parseFloat(record.workingMinutes) - this.convertHourstoMinute(record.user.hourDeduction * checkDays.totalWorkingHours)) + (this.convertHourstoMinute(record.user.totalPaidLeaves + record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.totalWorkingHours))
    //       let workingMinutes = ((parseFloat(record.workingMinutes) - this.convertHourstoMinute(record.user.hourDeduction * checkDays.totalWorkingHours)) + (this.convertHourstoMinute(record.user.totalPaidLeaves + record.user.paidLeaves + checkDays.employeeWeekendDays + checkDays.extraTime) * checkDays.shortTermWorkingHours))
    //       var hours = Math.floor(workingMinutes / 60);
    //       // var hours = parseFloat(workingMinutes/60).toFixed(2);
    //       var minutes = workingMinutes % 60;
    //       var formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    //       let workingHours = parseFloat(hours + '.' + formattedMinutes);
    //       // let workingHours = parseFloat(hours);
    //       if (workingHours > totalAllowedHours) {
    //         return (
    //           <div>
    //             <FaRupeeSign />{(parseFloat(salaryPerDay) * (totalAllowedHours / checkDays.totalWorkingHours)).toFixed(2)}
    //           </div>
    //         )
    //       } else {
    //         // let totalDays = (this.convertHourstoMinute(workingHours) / (checkDays.totalWorkingHours * 60)).toFixed(2)
    //         let totalDays = (workingHours / checkDays.totalWorkingHours).toFixed(2)

    //         return (
    //           <div>
    //             <FaRupeeSign />{(parseFloat(salaryPerDay) * totalDays).toFixed(2)}
    //           </div>
    //         )
    //       }

    //     }
    //   },
    //   {
    //     title: 'Deduct Extra Hours',
    //     key: 'operation1',
    //     dataIndex: 'operation1',
    //     width: 150,
    //     render: (text, record) => {
    //       let recordList = _.clone(record)
    //       return (
    //         <div>
    //           <Tooltip title="Deduct Extra Hours">
    //             <Checkbox style={{ marginLeft: '10px' }} key={record._id.userId}
    //               checked={
    //                 userCheckBox[record._id] ? userCheckBox[record._id].isDeductChecked : false
    //               }
    //               onChange={(y) => {
    //                 this.deductExtraHours(y, record._id, recordList)
    //               }} />
    //               <Input onChange={(e)=>{this.hoursDeductAmount(e.target.value, record._id, recordList)}} hidden={userCheckBox[record._id] ? !userCheckBox[record._id].isDeductChecked : true} />
    //           </Tooltip>
    //         </div>
    //       )
    //     }
    //   },
    //   {
    //     title: 'Previous Adjustments (INR)',
    //     key: 'operation2',
    //     dataIndex: 'operation2',
    //     width: 150,
    //     render: (text, record) => {
    //       let recordList = _.clone(record)
    //       return (
    //         <div>
    //           <Tooltip title="Previous Adjustments">
    //             <Checkbox style={{ marginLeft: '10px' }} key={record._id.userId}
    //               checked={
    //                 userCheckBox[record._id] ? userCheckBox[record._id].isPreviousAdjustmentChecked : false
    //               }
    //               onChange={(y) => {
    //                 this.deductPreviousAdjustments(y, record._id, recordList)
    //               }} />
    //               <Input onChange={(e)=>{this.previousAdjustmentAmount(e.target.value, record._id, recordList)}} hidden={userCheckBox[record._id] ? !userCheckBox[record._id].isPreviousAdjustmentChecked : true} />
    //           </Tooltip>
    //         </div>
    //       )
    //     }
    //   },
    //   // {
    //   //   title: 'Total Login Attemtps',
    //   //   key: 'totalAttempts',
    //   //   render: (text, record) => (
    //   //     <div> <FaSignInAlt /> {text } </div>
    //   //   )
    //   // },
    //   {
    //     title: 'Action',
    //     key: 'operation',
    //     dataIndex: 'operation',
    //     width: 150,
    //     render: (text, record) => {
    //       let currentYearMonth = moment().startOf('month').format('YYYY-MM');
    //       let iconShowMonth = moment(record._id.attendanceYearMonth, 'YYYY-MM').startOf('month').add(1, 'month').format('YYYY-MM');
    //       // if(currentYearMonth === iconShowMonth) {
    //       let recordList = _.clone(record)
    //       recordList.extraHours = extraHours
    //       let leavesPaid = paidLeaves > 0 ? paidLeaves * 8 : 0
    //       recordList.paidLeaves = leavesPaid + 8
    //       return (
    //         <div>
    //           <Tooltip title="Send For Verification">
    //             <Button
    //               size={'small'}
    //               shape="circle"
    //               icon="forward"
    //               onClick={() => this.sendForVerification(recordList)} />
    //           </Tooltip>
    //           <Checkbox style={{ marginLeft: '10px' }} key={record._id.userId}
    //             checked={
    //               userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false
    //             }
    //             onChange={(y) => {
    //               this.selectUser(y, record._id, recordList);
    //             }}
    //           />
    //           {/* <Tooltip title="Deduct Extra Hours">
    //             <Checkbox style={{ marginLeft: '10px' }} key={record._id.userId}
    //               checked={
    //                 userCheckBox[record._id] ? userCheckBox[record._id].isDeductChecked : false
    //               }
    //               onChange={(y) => {
    //                 this.deductExtraHours(y, record._id, recordList)
    //               }} />
    //           </Tooltip> */}

    //         </div>
    //       )
    //       // }
    //     }

    //   }
    // ]
    const columns = [
      {
        title: '#',
        key: 'serialNumber',
        width: 40,
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: 'User Name',
        key: 'userName',
        render: (text, record) => (
          <div><a href={`staff-login-history?id=${record.userId}&yearMonth=${record.attendanceYearMonth}`}><FaUserAstronaut /> {record.userName} </a></div>
        )
      },
      {
        title: 'Month',
        key: 'attendanceYearMonth',
        render: (text, record) => (
          <div> {record.attendanceYearMonth} </div>
        )
      },
      {
        title: 'Basic Salary',
        key: 'userMonthlySalary'
      },
      {
        title: 'Per Day Salary',
        key: 'perDaySalary',
        render: (text, record) => {
          let salary = record.userMonthlySalary ? parseFloat(record.userMonthlySalary) : 0;
          let daysInMonth = record.getTotalWorkingData && record.getTotalWorkingData.totalWorkingDays ? parseFloat(record.getTotalWorkingData.totalWorkingDays) : 0;
          return (
            <div>{(salary / daysInMonth).toFixed(2)}</div>
          )
        }
      },
      {
        title: 'Total Worked Hours',
        key: 'totalHours',
      },
      {
        title: 'Extra Hours',
        key: 'extraHours',
      },
      {
        title: 'Leave Hours/Days',
        key: 'deduction',
        render: (text, record) => (
          <div>{record.hourDeduction} / {record.deductionDays}</div>
        )
      },
      {
        title: 'Total Hours / Days',
        key: 'hoursDays',
        dataIndex: 'hoursDays',
        render: (text, record) => (
          <div>{record.totalHoursWorked} / {record.totalDaysWorked}</div>
        )
      },
      {
        title: 'Salary Before Deduction',
        key: 'staffSalary',
        dataIndex: 'staffSalary',
        render: (text, record) => (
          <div>{record.staffSalary.toFixed(2)}</div>
        )
      },
      {
        title: 'Deduct Extra Hours',
        key: 'operation1',
        dataIndex: 'operation1',
        width: 150,
        render: (text, record) => {
          let recordList = _.clone(record)
          return (
            <div>
              <Tooltip title="Deduct Extra Hours">
                <Checkbox style={{ marginLeft: '10px' }} key={record._id}
                  checked={
                    userCheckBox[record._id] ? userCheckBox[record._id].isDeductChecked : false
                  }
                  onChange={(y) => {
                    this.deductExtraHours(y, record._id, recordList)
                  }} />
                <Input onChange={(e) => { this.hoursDeductAmount(e.target.value, record._id, recordList) }} hidden={userCheckBox[record._id] ? !userCheckBox[record._id].isDeductChecked : true} />
              </Tooltip>
            </div>
          )
        }
      },
      {
        title: 'Previous Adjustments (INR)',
        key: 'operation2',
        dataIndex: 'operation2',
        width: 150,
        render: (text, record) => {
          let recordList = _.clone(record)
          return (
            <div>
              <Tooltip title="Previous Adjustments">
                <Checkbox style={{ marginLeft: '10px' }} key={record._id}
                  checked={
                    userCheckBox[record._id] ? userCheckBox[record._id].isPreviousAdjustmentChecked : false
                  }
                  onChange={(y) => {
                    this.deductPreviousAdjustments(y, record._id, recordList)
                  }} />
                <Input onChange={(e) => { this.previousAdjustmentAmount(e.target.value, record._id, recordList) }} hidden={userCheckBox[record._id] ? !userCheckBox[record._id].isPreviousAdjustmentChecked : true} />
              </Tooltip>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Send For Verification">
              <Button
                size={'small'}
                shape="circle"
                icon="forward"
                disabled={record.sentForConfirmation}
                type={record.sentForConfirmation ? 'primary' : 'default'}
                onClick={() => this.sendForVerification(record)} />
            </Tooltip>

            <Checkbox style={{ marginLeft: '10px' }} key={record._id}
              checked={
                userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false
              }
              onChange={(y) => {
                this.selectUser(y, record._id, record)
              }} />
          </React.Fragment>
        )
      }
    ]


    const salaryColumns = [
      {
        title: 'S No.',
        key: 'serialNumber',
        width: 60,
        fixed: true,
        render: (text, record, index) => {
          return (
            <span>{index + 1}</span>
          )
        }
      },
      {
        title: 'Staff Member',
        key: 'staffName',
        dataIndex: 'staffId.name',
        searchTextName: 'staffName',
        regExFilters: true
      },
      {
        title: 'Company',
        key: 'company'
      },
      {
        title: 'Department',
        key: 'department',
        render: (text, record) => {
          return (<div>{record.staffId && record.staffId.department}</div>)
        }
      },
      {
        title: 'Staff Salary',
        key: 'staffSalary'
      },
      {
        title: 'Salary/Increment File',
        key: 'salaryProof',
        render: (_, record) =>
          record.salaryProof && record.salaryProof.length > 0 ? (
            <Button
              icon="eye"
              type="primary"
              onClick={() =>
                window.open(
                  `${MEDIA_URL}${record.salaryProof[0].url}`,
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            />
          ) : null
      },
      {
        title: 'Working Days',
        key: 'workingDays',
        render: (text, record) => (
          <span>{text}</span>
        )
      },
      {
        title: 'Shift Timing',
        key: 'shiftTiming'
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'staffSalaryManagement.edit'}>
              <Tooltip title="Edit Staff Salary">
                <Button
                  shape="circle"
                  onClick={() => {
                    this.setStaffSalaryListData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'staffSalaryManagement.delete'}>
              <Tooltip title="Delete Staff Salary">
                <Popconfirm
                  title="Are you sure delete this Staff Salary?"
                  onConfirm={() => {
                    this.deleteStaffSalaryList({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]

    const salaryInputTypes = {
      fields: [
        {
          label: "Staff Member",
          key: "staffId",
          type: "select",
          showSearch: true,
          required: true,
          allowClear: true,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.display,
          options: this.state.allUsers ? this.state.allUsers : {},
          onChange: (v) => {
            this.props.form.setFieldsValue({ staffId: v });
          },
        },
        {
          label: 'Staff Salary',
          key: 'staffSalary',
          required: true,
          disabled: ((localUser.isAdministrator || localUser.isFinanceAdmin) ? false : (!this.state.salaryId ? false : true)),
        },
        {
          label: 'Company',
          key: "company",
          required: true,
          type: 'select',
          options: accountPaymentCompaniesArray,
          onChange: v => {
            this.props.form.setFieldsValue({ company: v })
          }
        },
        {
          label: 'Shift Timing',
          key: 'shiftTiming',
          type: 'select',
          options: shiftTiming,
          required: true,
          regExFilters: true,
          onChange: v => {
            this.props.form.setFieldsValue({ shiftTiming: v })
          }
        },
        {
          label: 'Working Days',
          key: 'workingDays',
          required: true,
          type: 'select',
          options: workingDays,
          mode: 'multiple',
          onChange: v => {
            this.props.form.setFieldsValue({ workingDays: v })
          }
        },
        {
          label: 'Salary/Increment Proof (if Any)',
          key: 'salaryProof',
          type: 'file',
        }
      ]
    };
    return (
      <PageHeaderWrapper title={` Salary Management `}>

        {
          this.state.showSupportStaffSalaryDrawer ?
            <AddSupportStaffSalary onClose={this.closeSupportStaff} />
            : null
        }
        <Card>
          <Tabs type="card" activeKey={this.state.activeTab} onChange={this.callback} destroyInactiveTabPane>
            {/* Overall Report Tab */}
            <TabPane tab={"Overall Report"} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              {/* Filters */}
              <Row>
                <Col span={8}>
                  <h4>Search By Year</h4>
                  <Select
                    allowClear
                    showSearch={true}
                    value={this.state.filterYear}
                    placeholder="Select Year"
                    style={{ width: '90%' }}
                    onChange={filterYear => {
                      this.setState({ filterYear }, () => {
                        setTimeout(() => {
                          this.reload()
                        }, 500);
                      })
                    }}>
                    {years && years.map((year, index) => {
                      return (
                        <Option key={index} value={year.key}>
                          {year.value}
                        </Option>
                      )
                    })}
                  </Select>
                </Col>
                <Col span={8}>
                  <h4>Search By Month</h4>
                  <Select
                    allowClear
                    showSearch={true}
                    value={this.state.filterMonth}
                    placeholder="Select Month"
                    style={{ width: '90%' }}
                    onChange={filterMonth => {
                      this.setState({ filterMonth }, () => {
                        setTimeout(() => {
                          this.reload()
                        }, 500);
                      })
                    }}>
                    {months && months.map((month, index) => {
                      return (
                        <Option key={index} value={month.key}>
                          {month.value}
                        </Option>
                      )
                    })}
                  </Select>
                </Col>
                <Col span={8}>
                  <h4>Search By User</h4>
                  <Select
                    allowClear
                    showSearch={true}
                    style={{ width: '90%' }}
                    value={this.state.userId}
                    placeholder="Select Option"
                    optionFilterProp="name"
                    onChange={userId => {
                      this.setState(
                        {
                          userId: userId && userId.toString()
                        },
                        () => {
                          setTimeout(() => {
                            this.reload()
                          }, 500);
                        }
                      );
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}>
                    {
                      allUsers.map((val, idn) => {
                        return (
                          <Option key={idn} value={val._id}>
                            {val.display}
                          </Option>
                        )
                      })
                    }
                  </Select>
                </Col>
              </Row>
              {/* Buttons */}
              <Row>
                <Col span={3}>
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    {
                      userRights.checkRights("StaffOverallExcelExport.view") ?
                        <Button type={'default'}
                          loading={this.state.exportLoading}
                          onClick={() => {
                            this.exportExcel()
                          }}>Export Excel</Button>
                        : null
                    }
                  </div>
                </Col>
                <Col span={3}>
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Button onClick={() => this.handleSendForVerification()}>Send For Verification</Button>
                  </div>
                </Col>
                <Col span={3}>
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Button onClick={() => this.selectAllUserFxn()}> Select Visible </Button>
                  </div>
                </Col>
                <Col span={3}>
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Button onClick={() => this.unselectAllUserFxn()}> Unselect Visible</Button>
                  </div>
                </Col>
              </Row>
              {/* Table */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 1200 } }}
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: defaultPageSize,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            {/* Salary Approval Report Tab */}
            <TabPane tab={"Salary Approvals"} key={1}>
              <h2>{`Total : ${this.state.approvalTotal}`}</h2>
              {/* Filters */}
              <Row>
                <Col span={6}>
                  <label>Search By Month</label>
                  <MonthPicker placeholder='Select Month' defaultValue={moment(this.state.approvalMonth, 'YYYY-DD')} format="YYYY-MM" onChange={this.handleApprovalMonthChange} />
                </Col>
                <Col span={6}>
                  <label>Search by User</label>
                  <Select
                    allowClear
                    showSearch={true}
                    style={{ width: '90%' }}
                    value={this.state.approvalUserId}
                    placeholder="Select Option"
                    optionFilterProp="name"
                    onChange={userId => {
                      this.setState(
                        {
                          approvalUserId: userId && userId.toString()
                        },
                        () => {
                          setTimeout(() => {
                            this.reload()
                          }, 500);
                        }
                      );
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {
                      allUsers.map((val, idn) => {
                        return (
                          <Option key={idn} value={val._id}>{val.display}</Option>
                        )
                      })
                    }

                  </Select>
                </Col>
                <Col span={3}>
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    {
                      userRights.checkRights("StaffSalariesExcelExport.view") ?
                        <Button type={'default'}
                          loading={this.state.exportLoading}
                          onClick={() => {
                            this.exportApprovalExcel()
                          }}>Export Excel</Button>
                        : null
                    }
                  </div>
                </Col>
                <Col span={3}>
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Button type={'default'}
                      loading={this.state.exportLoading}
                      onClick={() => {
                        this.addSupportStaffSalary()
                      }}>Add</Button>
                  </div>
                </Col>
              </Row>
              {/* Table */}
              <TableComp
                ref={this.table}
                columns={approvalColumns}
                apiRequest={this.apiApprovalRequest}
                extraProps={{ scroll: { x: 1800 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: defaultPageSize,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
              <h3>Totals:-</h3>
              <table style={{ width: '100%', textAlign: 'center' }}>
                <thead>
                  <tr>
                    <th>Basic Salary</th>
                    <th>Salary Before Deductions</th>
                    <th>Total EPF</th>
                    <th>Total ESIC</th>
                    {/* <th>Total CTC Deduction</th> */}
                    <th>Total Take Home Salary</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{this.state.totals && this.state.totals.totalBasicSalary ? this.state.totals.totalBasicSalary.toFixed() : 0}</td>
                    <td>{this.state.totals && this.state.totals.salaryBeforeDeduct ? this.state.totals.salaryBeforeDeduct.toFixed() : 0}</td>
                    <td>{this.state.totals && this.state.totals.totalEPF ? this.state.totals.totalEPF.toFixed() : 0}</td>
                    <td>{this.state.totals && this.state.totals.totalESIC ? this.state.totals.totalESIC.toFixed() : 0}</td>
                    {/* <td>{this.state.totals && this.state.totals.totalCtcDeduct?this.state.totals.totalCtcDeduct.toFixed():0}</td> */}
                    <td>{this.state.totals && this.state.totals.totalTakeHomeSalary ? this.state.totals.totalTakeHomeSalary.toFixed() : 0}</td>
                  </tr>
                </tbody>
              </table>
            </TabPane>
            {/* Salary Management */}
            <TabPane tab={"Salary Management"} key={2}>
              <Card>
                <Tabs type="card" activeKey={this.state.salaryManagementTab} onChange={this.salaryCallBack}>
                  <TabPane tab={`All List`} key={0}>
                    <h2>{`Total : ${this.state.salaryManagementTotal}`}</h2>
                    <TableComp
                      ref={this.table}
                      columns={salaryColumns}
                      apiRequest={this.apiSalaryRequest}
                      extraProps={{ scroll: { x: 1200 } }}
                      pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                      }}
                    />
                  </TabPane>
                  <TabPane tab={(id ? 'Edit' : 'Add') + ' Staff Salary'} key={1}>
                    <Form onSubmit={this.handleSalarySubmit} style={{ marginTop: 8 }}>
                      <GetAllFormFields
                        inputSchema={salaryInputTypes}
                        refresh={this.refreshFxn}
                        apiurl={LAPI_URL}
                        getFieldDecorator={getFieldDecorator}
                      />
                      <Button
                        type=""
                        htmlType="submit"
                        style={{
                          marginBottom: 10,
                          marginLeft: '33%',
                          backgroundColor: 'green',
                          color: 'white'
                        }}
                        loading={this.props.loading}>
                        SAVE
                      </Button>
                      <Button
                        type="primary"
                        style={{ marginBottom: 10, marginLeft: '1%' }}
                        loading={this.props.loading}
                        onClick={() => {
                          this.props.form.resetFields()
                        }}>
                        RESET
                      </Button>
                    </Form>
                  </TabPane>
                </Tabs>
              </Card>


            </TabPane>
            {/* Support Staff Salary Management */}
            <TabPane tab={"Support Staff Salary"} key={3}>
              <Card>
                <Tabs type="card" activeKey={this.state.supportStaffTab} onChange={this.changeSupportStaff}>
                  <TabPane tab={`All List`} key={0}>
                    <h2>{`Total : ${this.state.supportStafftotal}`}</h2>
                    <TableComp
                      ref={this.table}
                      columns={supportStaffColumns}
                      apiRequest={this.apiSupoortRequest}
                      extraProps={{ scroll: { x: 900 } }}
                      pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 50,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                      }}
                    />
                  </TabPane>
                  <TabPane tab={(id ? 'Edit' : 'Add') + ' Staff Salary'} key={1}>
                    <Form onSubmit={this.handleSupportSalarySubmit} style={{ marginTop: 8 }}>
                      <GetAllFormFields
                        inputSchema={supportStaffInputTypes}
                        refresh={this.refreshFxn}
                        getFieldDecorator={getFieldDecorator}
                      />
                      <Button
                        type=""
                        htmlType="submit"
                        style={{
                          marginBottom: 10,
                          marginLeft: '33%',
                          backgroundColor: 'green',
                          color: 'white'
                        }}
                        loading={this.props.loading}>
                        SAVE
                      </Button>
                      <Button
                        type="primary"
                        style={{ marginBottom: 10, marginLeft: '1%' }}
                        loading={this.props.loading}
                        onClick={() => {
                          this.props.form.resetFields()
                        }}>
                        RESET
                      </Button>
                    </Form>
                  </TabPane>
                </Tabs>
              </Card>
            </TabPane>
          </Tabs>
        </Card>


      </PageHeaderWrapper>
    );
  }
}

export default AllStaffOverallReport
